import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormArray } from '@angular/forms';
import { find as _find, sortBy as _sortBy, uniqBy as _uniqBy } from 'lodash';

import { removeIcon } from '@app/app.constants';
import { SubjectFileModel } from '@app/_interfaces/SubjectFileModel';
import { EXERCISE_TYPES } from '@app/app.constants';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-select-files',
    templateUrl: './select-files.component.html',
    styleUrls: ['./select-files.component.scss']
})
export class SelectFilesComponent implements OnInit {
    static savedFilters = {};

    files: SubjectFileModel[] = [];
    initialSubtopics: SubjectFileModel[] = [];
    box_level: number;
    box_title: number;
    @Input() isRisk: boolean;

    startSubtopics: SubjectFileModel[];
    choosedFiles: SubjectFileModel[] = [];
    titleString = '';
    subtopics = [];
    allThemes: SubjectFileModel[] = [];
    onlyOneType = true;

    themeForm: FormGroup;
    removeIcon = removeIcon;
    radioOrder: { title: string; name: EXERCISE_TYPES }[] = [
        {
            title: 'все',
            name: EXERCISE_TYPES.EXERCISE_ALL
        },
        {
            title: 'магический квадрат',
            name: EXERCISE_TYPES.EXERCISE_MAGIC_BOX
        },
        {
            title: 'логическая задача',
            name: EXERCISE_TYPES.EXERCISE_LOGIC
        },
        {
            title: 'ребус пример',
            name: EXERCISE_TYPES.EXERCISE_PUZZLE_EXAMPLE
        },
        {
            title: 'ребус задача',
            name: EXERCISE_TYPES.EXERCISE_PUZZLE_TASK
        },
        {
            title: 'последовательность',
            name: EXERCISE_TYPES.EXERCISE_SEQUENCE
        },
        {
            title: 'задача',
            name: EXERCISE_TYPES.EXERCISE_TASK
        },
        {
            title: 'пример',
            name: EXERCISE_TYPES.EXERCISE_CALCULATION
        },
        {
            title: 'вставка',
            name: EXERCISE_TYPES.EXERCISE_INSERT
        }
    ];

    @Output() closeBtnClicked: EventEmitter<boolean> = new EventEmitter();
    @Output() emitChoosedFiles: EventEmitter<Array<SubjectFileModel>> = new EventEmitter();

    constructor(
        protected fb: FormBuilder,
        @Inject(MAT_DIALOG_DATA) protected data: any,
        private dialogRef: MatDialogRef<SelectFilesComponent>
    ) {}

    enterClicked() {
        this.dialogRef.close(this.startSubtopics);
    }

    closeClicked() {
        this.dialogRef.close();
    }

    ngOnInit() {
        this.files = this.data.files || [];
        this.box_level = this.data.title;
        this.box_title = this.data.level;
        this.startSubtopics = [...this.data.initialSubtopics];
        this.changeSubtopics(this.files);
        this.getAllThemes();
    }

    changeSubtopics(files = null) {
        const currentThemes = files || this.choosedFiles;
        this.subtopics = [];

        currentThemes.forEach(file => {
            this.subtopics.push(file);
        });

        this.subtopics = _sortBy(this.subtopics, 'subtopic_title');
    }

    getAllThemes() {
        this.allThemes = _sortBy(_uniqBy(this.files, 'theme_title'), 'theme_order');

        this.themeForm = new FormGroup({
            all: new FormControl(true),
            themes: this.fb.array(
                this.allThemes.map((t: SubjectFileModel) => {
                    return this.fb.group({
                        val: [false],
                        label: [t.theme_title],
                        file_type: [t.file_type]
                    });
                })
            ),
            type: new FormControl('все')
        });

        this.themeForm.patchValue(SelectFilesComponent.savedFilters);

        this.filter();

        this.themeForm.valueChanges.subscribe(() => {
            this.filter();
        });
    }

    chooseSubtopic(subtopic) {
        if (this.startSubtopics.indexOf(subtopic) === -1) {
            this.startSubtopics.push(subtopic);
        }
    }

    removeFromChoosed(subtopic) {
        const index = this.startSubtopics.indexOf(subtopic);
        this.startSubtopics.splice(index, 1);
    }

    removeFromAllChoosedSubtopics() {
        this.startSubtopics = [];
    }

    filterFilesByAttr() {
        if (this.choosedFiles.length === 0) {
            this.changeSubtopics(this.files);
        } else {
            this.changeSubtopics();
        }

        this.subtopics = this.subtopics.filter(subtopic =>
            subtopic.subtopic_title.toLowerCase().includes(this.titleString.toLowerCase())
        );
    }

    private filter() {
        const formData = this.themeForm.getRawValue();
        const selectedFileType = _find<any>(this.radioOrder, { title: formData.type });
        SelectFilesComponent.savedFilters = formData;

        if (formData.type === 'все') {
            this.choosedFiles = this.files;
        } else {
            this.choosedFiles = this.files.filter(file => {
                const isEnabled = formData.themes.some(({ label, val }) => val && label === file.theme_title);
                const response = (formData.all || isEnabled) && file.file_type === selectedFileType.name;
                return response;
            });
        }

        if (!formData.all) {
            this.choosedFiles = this.choosedFiles.filter(file => {
                return formData.themes.some(({ label, val }) => val && label === file.theme_title);
            });
        }

        this.changeSubtopics();
    }

    checkAllthemes(isAll: boolean) {
        if (!isAll) {
            this.themeForm.controls['all'].setValue(false);
            return;
        }

        const items = <FormArray>this.themeForm.get('themes');
        for (let i = 0; i < items.length; i++) {
            items.at(i).patchValue({ val: false });
        }
    }
}
